export interface CompanyExposureAccount {
  countryCode: string;
  actualDeductible: number;
  targetDeductible: number;
  actualLimits: number;
  sic4: string;
  eil: string;
  companyName: string;
  targetLimits: number;
  contactName: string;
  recordType: string;
  recordsRange: string;
  website: string;
  revenue: number;
  contactEmail: string;
  companySize: string;
}

export interface ExposureValueRequest {
  companyName: string;
  countryCode: string;
  sic4: string;
  revenue: number;
  revenueEffectiveDate: Date | null;
  actualLimits: number;
  targetLimits: number;
  actualDeductible: number;
  targetDeductible: number;
}

export interface AnalysisStatus {
  status: string;
  code: string;
  message: string;
  details?: string[];
}

export interface AggregateLoss {
  percentile: number;
  loss: number;
}

export interface CostComponentLoss {
  name: string;
  loss: number;
}

export interface LossDistribution {
  percentile: number;
  loss: number;
  costComponentsLoss: CostComponentLoss[];
}

export interface LossFactor {
  name: string;
  lossDistribution: LossDistribution[];
}

export interface AnalysisResult {
  accountId: string;
  analysisId: string;
  analysisStatus: AnalysisStatus;
  aggregateLoss: AggregateLoss[];
  lossFactors: LossFactor[];
}

export interface CompanyActualLimitsAndRetention {
  actualLimits: number | null;
  actualRetention: number | null;
}

export interface AnalysisRun {
  id: string;
  status: AnalysisRunStatus;
  createdAt: Date;
  UpdatedAt: Date;
}

export interface CurrentVSAggregateExposure {
  accountId: number;
  percentile: number;
  currentLimit: number;
  point1: number;
  point2: number;
  point3: number;
  point4: number;
  point5: number;
  point6: number;
  point7: number;
  point8: number;
  point9: number;
  matureLoss: number;
}

export interface CyberModelDetails {
  id: string;
  accountId: string;
  accountName: string;
  createdDate: string;
  updatedDate: string;
  createdBy?: string;
  published: boolean;
}

export enum Maturity {
  IMMATURE = 'IMMATURE',
  MATURE = 'MATURE',
  NONE = 'NONE',
}

export enum AnalysisStatusEnum {
  SUCCESS = 'SUCCESS',
  RUNNING = 'RUNNING',
  ERROR = 'ERROR',
  TIMEOUT = 'TIMEOUT',
}

export enum AnalysisRunStatus {
  QUEUED = 'QUEUED',
  SUCCESS = 'SUCCESS',
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
}
